import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (selectTime) {

  const { isRequestSuccessed, data, exec } = useRequest({
    name: 'GET_PRODUCE_CLASSES_SELECT',
    url: '',
    method: 'GET'
  });
  useEffect(() => {
    if (selectTime) {
      exec(`/api/produce-classes?select_time=` + selectTime)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectTime]);
  return [isRequestSuccessed, data || []];
});
